var React = require('react');

function Search (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M11.1404 12.516C9.97884 13.3732 8.54015 13.8803 6.9823 13.8803C3.12608 13.8803 0 10.7731 0 6.94016C0 3.10721 3.12608 0 6.9823 0C10.8385 0 13.9646 3.10721 13.9646 6.94016C13.9646 8.53782 13.4215 10.0094 12.5087 11.1824L15.7199 14.3742C16.094 14.7461 16.094 15.3491 15.7199 15.721C15.3457 16.0929 14.739 16.0929 14.3649 15.721L11.1404 12.516ZM12.1365 6.98384C12.1365 9.78901 9.84861 12.063 7.0264 12.063C4.2042 12.063 1.91635 9.78901 1.91635 6.98384C1.91635 4.17867 4.2042 1.90463 7.0264 1.90463C9.84861 1.90463 12.1365 4.17867 12.1365 6.98384Z","fill":"#262626"}));
}

Search.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = Search;

Search.default = Search;
